/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../elements/Button';

export default function CTAFloatCard({
  title,
  description,
  buttonText,
  buttonLink,
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.25 },
    );

    observer.observe(el);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={ref}
      className={`
        relative z-20 -mt-32 px-4 pb-8
        transition-all duration-700 ease-out
        ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}
      `}
    >
      <div className="max-w-4xl mx-auto relative">
        {/* Glow behind card */}
        <div className="absolute -inset-1 bg-gradient-to-r from-brand-green-400/20 via-brand-green-300/10 to-brand-green-400/20 rounded-3xl blur-xl" />

        <div className="relative glass-card-static px-8 py-14 text-center rounded-3xl border border-brand-green-100/50">

          <h2 className="text-3xl sm:text-4xl font-extrabold text-surface-900 mb-4 tracking-tight">
            {title}
          </h2>

          <p className="text-surface-300 text-base sm:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            {description}
          </p>

          <Button
            href={buttonLink}
            type="link"
            className="btn-premium text-base px-10 py-4"
          >
            {buttonText}
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Button>

        </div>
      </div>
    </section>
  );
}

CTAFloatCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
};

CTAFloatCard.defaultProps = {
  buttonText: 'BOOK A CONSULTATION',
  buttonLink: '/book-consultation',
};
